import { render, staticRenderFns } from "./ClientsSection.vue?vue&type=template&id=698b51ea&scoped=true"
import script from "./ClientsSection.vue?vue&type=script&lang=js"
export * from "./ClientsSection.vue?vue&type=script&lang=js"
import style0 from "./ClientsSection.vue?vue&type=style&index=0&id=698b51ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b51ea",
  null
  
)

export default component.exports